import flagsmith from 'flagsmith';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useFlagsmithLoading } from 'flagsmith/react';
import { FeatureFlagsActions } from '../../store/reducers/featureFlags';

export function FlagsmithIdentity({ children }) {
  const dispatch = useDispatch();
  const { isLoading } = useFlagsmithLoading();
  const { user } = useSelector((state) => state.role);

  const { loading: loadingIdentity, identity } = useSelector((state) => state.featureFlags);

  useEffect(() => {
    if (isLoading || loadingIdentity) return;

    if (!user) {
      return dispatch({ type: FeatureFlagsActions.SET_IDENTITY, payload: null });
    }

    if (user.id === identity?.userId) {
      return;
    }

    (async () => {
      dispatch({ type: FeatureFlagsActions.LOADING_IDENTITY });

      const { id, email, role } = user;
      await flagsmith.identify(id, { email, role });

      dispatch({ type: FeatureFlagsActions.SET_IDENTITY, payload: { userId: user.id } });
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, user, identity, loadingIdentity]);

  return <>{children}</>;
}

FlagsmithIdentity.propTypes = {
  children: PropTypes.node.isRequired,
};
